import React from "react";
import TableComp from "src/components/shared/table/TableComp";
import useInventoryOutBody from "./utils/useInventoryOutBody";

export default function InventoryOutTable({ date, topbarSearchList, keyword, searchBy, paramsQuery, warehouseId }) {
  const { header, bodyList, error, isLoading, sortData, setPagi } = useInventoryOutBody({
    date,
    topbarSearchList,
    keyword,
    searchBy,
    paramsQuery,
    warehouseId,
  });

  return (
    <TableComp
      headers={header}
      bodyList={bodyList}
      isLoading={isLoading}
      error={error}
      sortData={sortData}
      setPagi={setPagi}
    />
  );
}
